import { TECHNOLOGY_REQUIRED_POSITION_IDS } from 'domain/shared/career';

export const positionProfileValidation = {
  specializationId: {
    type: 'string',
    required: true,
  },
  technologyId: {
    type: 'string',
    required: {
      value: true,
      when: {
        $specializationId: {
          in: TECHNOLOGY_REQUIRED_POSITION_IDS.flatMap(positionId => [positionId, String(positionId)]),
        },
      },
    },
  },
  competencyLevel: {
    type: 'string',
    required: true,
  },
  name: {
    type: 'string',
    required: true,
  },
  description: {
    type: 'string',
    maxSize: 2000,
  },
  salaryRanges: {
    type: 'array',
    maxSize: 3,
    forEach: {
      type: 'object',
      _divisible: false,
      properties: {
        minValue: {
          type: 'number',
          required: {
            value: true,
            when: {
              '$.maxValue': {
                notEmpty: true,
              },
            },
          },
          maxValue: {
            value: '$.maxValue',
            message: 'Min value cannot exceed max.',
          },
        },
        maxValue: {
          type: 'number',
          required: {
            value: true,
            when: {
              '$.minValue': {
                notEmpty: true,
              },
            },
          },
          minValue: {
            value: '$.minValue',
            message: 'Max value cannot be below min.',
          },
        },
      },
    },
  },
};
